import {
  Component,
  Input,
  ElementRef
} from '@angular/core';

import {
  SkyWaitAdapterService
} from './wait-adapter.service';


export class SkyWaitComponent {

  
  public set isWaiting(value: boolean) {
    if (value && !this._isFullPage) {
      this.adapterService.setWaitBounds(this.elRef);
    } else if (!value && !this._isFullPage) {
      this.adapterService.removeWaitBounds(this.elRef);
    }
    this.adapterService.setBusyState(this.elRef, this._isFullPage, value);
    this._isWaiting = value;
  }

  public get isWaiting() {
    return this._isWaiting;
  }

  
  public set isFullPage(value: boolean) {
    if (value) {
      this.adapterService.removeWaitBounds(this.elRef);
    } else if (!value && this._isWaiting) {
      this.adapterService.setWaitBounds(this.elRef);
    }

    this._isFullPage = value;
  }

  public get isFullPage() {
    return this._isFullPage;
  }

  
  public isNonBlocking: boolean;

  private _isWaiting: boolean;

  private _isFullPage: boolean;

  constructor(private elRef: ElementRef, private adapterService: SkyWaitAdapterService) { }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-wait',
  template: `<div class="sky-wait-container">
  <div
    *ngIf="isWaiting"
    [ngClass]="{
      'sky-wait-mask-loading-fixed': isFullPage,
      'sky-wait-mask-loading-non-blocking': isNonBlocking,
      'sky-wait-mask-loading-blocking': !isNonBlocking
      }"
    >
    <div class="sky-wait">
      <div class="sky-wait-double-bounce1"></div>
      <div class="sky-wait-double-bounce2"></div>
    </div>
  </div>
</div>

`,
  styles: [`.sky-wait-mask-loading-blocking {
  margin: auto;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1000;
}

.sky-wait-mask-loading-fixed {
  position: fixed;
}

.sky-wait {
  width: 50px;
  height: 50px;
  margin-top: -25px;
  margin-left: -25px;
  position: absolute;
  top: 50%;
  left: 50%;
}

.sky-wait-mask-loading-non-blocking {
  bottom: 0;
}

.sky-wait-mask-loading-non-blocking .sky-wait {
  top: auto;
  right: auto;
  bottom: 0;
  left: 0;
  margin-left: auto;
  margin-right: auto;
}

.sky-wait-double-bounce1, .sky-wait-double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #71bf43;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.sky-wait-double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

.sky-wait-container.sky-wait-active {
  position: relative;
}
`],
  providers: [SkyWaitAdapterService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: SkyWaitAdapterService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'isWaiting': [{ type: Input },],
'isFullPage': [{ type: Input },],
'isNonBlocking': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
